import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import {
    Button,
    Icon,
    Container,
    Loader
} from "semantic-ui-react";

function UserDetails(props) {
    const [state, setState] = useState({
        profile: {},
        repository: [],
        loading: true
    });

    const { uid } = useParams();

    useEffect(() => {
        const getUser = async () => {
            const client_id = process.env.REACT_APP_CLIENT_ID;
            const client_secret = process.env.REACT_APP_CLIENT_SECRET;
            setState({ ...state, loading: true });
            const profileResponse = await fetch(
                `https://api.github.com/users/${uid}?client_id=${client_id}&client_secret=${client_secret}`
            );

            const repoResponse = await fetch(
                `https://api.github.com/users/${uid}/repos?per_page=15&sort=stars&order=desc&client_id=${client_id}&client_secret=${client_secret}`
            );
            const profile = await profileResponse.json();
            const repos = await repoResponse.json();

            setState({ profile: profile, repository: repos, loading: false });
        };
        getUser();
        //eslint-disable-next-line
    }, [uid]);

    if (state.loading) {
        return (
            <Container>
                <div style={{ padding: "4rem", textAlign: "center" }}>
                    <Loader active size="large" />
                </div>
            </Container>
        );
    }

    return (
        <Container>
            <Button
                as={Link}
                to="/"
                content="← Back to Search"
                icon="arrow left"
                className="back-btn"
                style={{
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    color: "white"
                }}
            />

            {/* User Profile Header */}
            <div className="user-details-container">
                <div className="user-profile-header">
                    <img
                        src={state.profile.avatar_url}
                        alt={state.profile.name}
                        className="user-profile-avatar"
                    />
                    <div className="user-profile-name">{state.profile.name || state.profile.login}</div>
                    {state.profile.location && (
                        <div className="user-profile-location">
                            <Icon name="map marker alternate" />
                            {state.profile.location}
                        </div>
                    )}
                </div>

                {/* Bio Section */}
                {state.profile.bio && (
                    <div className="user-profile-bio">
                        <h3 style={{ color: "#667eea", marginBottom: "1rem", fontWeight: "700" }}>Bio</h3>
                        <p>{state.profile.bio}</p>
                    </div>
                )}

                {/* Contact Information */}
                <div className="user-profile-list">
                    <div className="item">
                        <Icon name="github" />
                        <strong>GitHub Username:</strong> <a href={state.profile.html_url} target="_blank" rel="noopener noreferrer">{state.profile.login}</a>
                    </div>
                    {state.profile.twitter_username && (
                        <div className="item">
                            <Icon name="twitter" />
                            <strong>Twitter:</strong> <a href={`https://twitter.com/${state.profile.twitter_username}`} target="_blank" rel="noopener noreferrer">@{state.profile.twitter_username}</a>
                        </div>
                    )}
                    {state.profile.blog && (
                        <div className="item">
                            <Icon name="globe" />
                            <strong>Website:</strong> <a href={state.profile.blog} target="_blank" rel="noopener noreferrer">{state.profile.blog}</a>
                        </div>
                    )}
                    {state.profile.company && (
                        <div className="item">
                            <Icon name="building" />
                            <strong>Company:</strong> {state.profile.company}
                        </div>
                    )}
                </div>

                {/* Stats Section */}
                <div className="user-stats">
                    <div className="stat-item">
                        <div className="stat-label">
                            <Icon name="book" /> Public Repos
                        </div>
                        <div className="stat-value">{state.profile.public_repos || 0}</div>
                    </div>
                    <div className="stat-item">
                        <div className="stat-label">
                            <Icon name="note" /> Public Gists
                        </div>
                        <div className="stat-value">{state.profile.public_gists || 0}</div>
                    </div>
                    <div className="stat-item">
                        <div className="stat-label">
                            <Icon name="users" /> Followers
                        </div>
                        <div className="stat-value">{state.profile.followers || 0}</div>
                    </div>
                    <div className="stat-item">
                        <div className="stat-label">
                            <Icon name="user plus" /> Following
                        </div>
                        <div className="stat-value">{state.profile.following || 0}</div>
                    </div>
                </div>

                {/* Profile Link Button */}
                <div style={{ padding: "2rem", textAlign: "center" }}>
                    <Button
                        as="a"
                        href={state.profile.html_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        content="Visit Full GitHub Profile"
                        icon="arrow right"
                        labelPosition="right"
                        style={{
                            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            color: "white",
                            fontWeight: "600",
                            padding: "12px 24px"
                        }}
                    />
                </div>
            </div>

            {/* Repositories Section */}
            {state.repository && state.repository.length > 0 && (
                <div style={{ marginTop: "2rem" }}>
                    <div className="repos-section">
                        <h2 className="repos-header">⭐ Top Repositories</h2>
                        {state.repository.map((repo, i) => (
                            <div key={i} className="repo-item">
                                <a
                                    href={repo.html_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="repo-link"
                                >
                                    📦 {repo.name}
                                </a>
                                {repo.description && (
                                    <p style={{ margin: "0.5rem 0", color: "#666", fontSize: "0.9rem" }}>
                                        {repo.description}
                                    </p>
                                )}
                                <div style={{ marginTop: "0.5rem", fontSize: "0.85rem", color: "#999" }}>
                                    {repo.language && (
                                        <span style={{ marginRight: "1rem" }}>
                                            💻 {repo.language}
                                        </span>
                                    )}
                                    {repo.stargazers_count > 0 && (
                                        <span>
                                            ⭐ {repo.stargazers_count} stars
                                        </span>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </Container>
    );
}
export default UserDetails;